<template>
  <div style="margin:20px 0;height:100%">
    <a-table 
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :row-key="record => record.id"
      bordered
      :scroll="{ x:400, y: 'calc(100vh - 300px)' }"
    >
      <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" slot="name" slot-scope="text">
        {{text}}
      </div>
    </a-table>
  </div>
</template>

<script>
import { nhfMixins } from '../../untils'
export default {
  props:['result','height'],
  mixins:[nhfMixins],
  data(){
    return {
      columns:[
        {
          dataIndex:'name',
          width: 320,
          fixed: 'left',
          title:"名称",
          scopedSlots: {customRender: 'name'},
        },
        {
          dataIndex:'code',
          width: 150,
          title:"代码",
        },
      ],
      dataSource:[],
    }
  },
  mounted(){
    this.initTableData()
  },
  methods:{
    initTableData(){
      const {ladderList,rawResList} = this.result
      if(rawResList && ladderList){
        let columns= JSON.parse(JSON.stringify( this.columns))
        ladderList.forEach(item => {
          columns.push( {
            dataIndex:item,
            title:item,
            width:100,
            align:'center',
          })
        })
        this.columns = columns
        const dataSource = []
        this.result.rawResList.forEach((i,id) => {
          i.forEach((item,index) => {
              const val = {[this.result.ladderList[id]]:item.percentage}
              const condition = i=>i.code === item.code
              if(dataSource.some(condition)){
                const idx = dataSource.findIndex(condition)
                dataSource.splice(idx,1,{...dataSource.filter(condition)[0],...val})
              } else {
                dataSource.push({
                  ...item,
                  id:`${id}${index}`,
                  ...val
                })
              }
          })
        })
        let arr = this.result.rawResList[0]
        dataSource.forEach( item =>{
          arr.forEach((i,id) =>{
            if(item.code === i.code) {
              arr[id] = {...item, ...i}
            }
          })
        }, [])
        this.dataSource = arr
        console.log(arr)
      }
    },
  }
}
</script>

<style>

</style>